import { memo } from 'react'
import { CommunityLinks } from './CommunityLinks'
import { ConnectionStatus } from './ConnectionStatus'
import { FooterPendingTransactions } from './DepositTransactions'
import { FooterItem, FooterWrap, FooterBottom, FooterFlexItem } from './styles'
import { DevTools } from '../../components/DevTools'

export const Footer = memo(() => {
  return (
    <FooterWrap>
      {/* <WhitelistWarning /> */}
      <FooterBottom>
        <FooterItem>
          <ConnectionStatus />
        </FooterItem>
        <FooterPendingTransactions />
        <DevTools />
        <FooterFlexItem />
        <CommunityLinks />
      </FooterBottom>
    </FooterWrap>
  )
})
